import React from 'react'
import {HighLevelTag, useTestTag} from 'Event/highlevel'
import {HIGHLEVEL} from 'organization/Event/Services/ServicesProvider'
import TestTagButton from 'organization/Event/Form/TestTagButton'

export default function TestHighLevelTagButton(props: {
  tag: HighLevelTag | null
}) {
  const addTag = useTestTag()

  return (
    <TestTagButton tag={props.tag} integration={HIGHLEVEL} addTag={addTag} />
  )
}
